// The extension sets owned by the Online3DViewer importer, kept in a dependency-free
// module of their own.
//
// file-handler.ts must know these lists eagerly, to route a file set and to build the
// picker's accept lists, but it loads the importer itself via a dynamic import() so the
// Online3DViewer/three.js stack stays out of the initial bundle. Declaring them in
// o3dv-import.ts and importing them statically defeats that: Rollup then hoists the whole
// module into the main chunk (measured: dist/index.js 5,645,452 -> 6,271,866 bytes, no
// separate chunk emitted). Living here, they cost nothing.

// Formats handled by Online3DViewer that the editor cannot already read. .glb, .gltf and
// .fbx are deliberately absent: they stay on the PlayCanvas-native and in-house importers.
// .ply is absent too - it is routed by content sniffing in file-handler.ts, because a .ply
// may be either a gaussian splat or a polygon mesh.
const O3DV_EXTENSIONS = [
    '.obj', '.stl', '.off', '.3ds', '.bim', '.3mf', '.amf',
    '.dae', '.wrl', '.3dm', '.ifc', '.step', '.stp', '.iges', '.igs', '.brep', '.fcstd'
];

// Files that are never a main file but must be accepted alongside one: .obj's material
// library, separate-form glTF's buffers, and texture images referenced by either.
const O3DV_COMPANION_EXTENSIONS = [
    '.mtl', '.bin', '.png', '.jpg', '.jpeg', '.bmp', '.gif', '.tga'
];

export { O3DV_EXTENSIONS, O3DV_COMPANION_EXTENSIONS };
